<template>
  <component :is="theme.components.BaseElementLayout" :el$="el$">
    <template slot="field">
      <v-flex xs-12>
        <v-btn color="success" @click="refreshPurchaseOrders()" flat icon>
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-flex>
      <slot name="prefix"></slot>
      <slot slot="label" name="label" :el$="el$"></slot>
      <div class="plant_used">
        <v-flex
          xs12
          v-for="(item, index) in this.usedPlants"
          :key="index"
          class="plant_used_item"
        >
          <div class="plant_used_item-divider">
            <hr />
            <v-btn icon @click="oRemovePlant(index)">
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
          </div>
          <input
            type="number"
            name="select_plant"
            :id="'select_plant_' + index"
            class="form-control"
            placeholder="Describe Plant"
            v-model="usedPlants[index]['select_plant']"
            @keyup="handlePlantsModel"
          />
          <v-switch
            v-model="usedPlants[index]['plant_hired']"
            inset
            label="Was this plant hired?"
          ></v-switch>
          <div class="purchase_orders" v-if="usedPlants[index]['plant_hired']">
            <v-flex
              xs12
              v-for="(po, poIndex) in purchase_orders"
              :key="po.POPH_Reference"
            >
              <v-card raised tile>
                <v-card-title
                  style="height:30px;"
                  color="gray"
                  :key="`title${poIndex}`"
                >
                  {{ po.POPH_Reference }}
                  <v-spacer></v-spacer>
                  £{{ po.POPH_Total_Value_Ex_VAT_Home }}
                </v-card-title>
                <v-card-text class="purchase_order">
                  {{ po.SUPP_Name }}
                  <v-flex xs-12>
                    <label>
                      <v-checkbox
                        v-model="
                          usedPlants[index]['hire_purchase_orders'][
                            po.POPH_Reference
                          ]['used']
                        "
                        label="Used"
                        @click="handlePlantsModel"
                      ></v-checkbox>
                    </label>
                  </v-flex>
                  <v-flex
                    xs-12
                    v-if="
                      usedPlants[index]['hire_purchase_orders'][
                        po.POPH_Reference
                      ]['used'] && po_type == 'MAT'
                    "
                  >
                    <v-label>GRN</v-label>
                    <input
                      type="number"
                      :name="po.POPH_Reference"
                      :id="po.POPH_Reference"
                      class="form-control"
                      placeholder="Enter GRN number"
                      v-model="
                        usedPlants[index]['hire_purchase_orders'][
                          po.POPH_Reference
                        ]['grn']
                      "
                      @keyup="handlePlantsModel"
                    />
                  </v-flex>
                  <v-flex
                    xs-12
                    v-if="
                      usedPlants[index]['hire_purchase_orders'][
                        po.POPH_Reference
                      ]['used'] && po_type == 'HIR'
                    "
                  >
                    <v-label>Off Hire Number</v-label>
                    <input
                      type="number"
                      :name="po.POPH_Reference"
                      :id="po.POPH_Reference"
                      class="form-control"
                      placeholder="Enter Off Hire number"
                      v-model="
                        usedPlants[index]['hire_purchase_orders'][
                          po.POPH_Reference
                        ]['off_hire_number']
                      "
                      @keyup="handlePlantsModel"
                    />
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
          </div>
        </v-flex>
        <hr />
        <v-btn color="primary" @click="onAddPlant()">
          Add
        </v-btn>
      </div>
      <slot name="suffix"></slot>
    </template>
    <slot slot="info" name="info" :el$="el$"></slot>
    <slot slot="before" name="before" :el$="el$"></slot>
    <slot slot="between" name="between" :el$="el$"></slot>
    <slot slot="error" name="error" :el$="el$"></slot>
    <slot slot="after" name="after" :el$="el$"></slot>
  </component>
</template>

<script>
import Vue from 'vue'
import BaseElement from '@laraform/laraform/src/mixins/BaseElement'
import BaseValidation from '@laraform/laraform/src/mixins/BaseValidation'
import TextElement from '@laraform/laraform/src/themes/bs4/components/elements/TextElement'
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'

export default {
  name: 'PurchaseOrders',
  mixins: [BaseElement, BaseValidation, TextElement],
  data: () => ({
    usedPlants: [],
    purchase_orders: []
  }),
  mounted() {
    this.refreshPurchaseOrders()
    // console.log(this.purchaseOrderData)
  },
  methods: {
    ...mapActions({
      fetchPurchaseOrders: 'calls/fetchPurchaseOrders'
    }),
    onAddPlant() {
      const pOrdersModel = {}
      this.purchase_orders.map(p => {
        let pData = {
          used: false,
          grn: null
        }
        pOrdersModel[p.POPH_Reference] = pData
      })
      this.usedPlants.push({
        select_plant: '',
        plant_hired: false,
        hire_purchase_orders: { ...pOrdersModel }
      })
      this.handlePlantsModel()
    },
    oRemovePlant(index) {
      this.usedPlants = this.usedPlants.filter((item, i) => i !== index)
      this.handlePlantsModel()
    },
    refreshPurchaseOrders() {
      this.loading = true
      this.purchase_orders = []
      this.fetchPurchaseOrders({
        id: this.getActiveCall.call_remote_id,
        call_assignment_id: this.getActiveCall.call_assignment_id,
        type: this.po_type ? this.po_type : 'MAT'
      }).then(r => {
        this.purchase_orders = r
        this.loading = false
        this.initializeUsedPlants()
      })
    },
    handlePlantsModel() {
      this.update(this.usedPlants)
    },
    initializeUsedPlants() {
      const newPlants = []
      if (this.plantOrderData && Array.isArray(this.plantOrderData)) {
        console.log(this.plantOrderData, 'plantOrderData')
        this.plantOrderData.map(item => {
          const newItem = {
            select_plant: item.select_plant,
            plant_hired: item.plant_hired,
            hire_purchase_orders: {}
          }
          console.log(this.purchase_orders, 'purchase_orders')
          this.purchase_orders.map(po => {
            let poData = {
              used: false,
              grn: null
            }
            if (item['hire_purchase_orders'][po.POPH_Reference] !== undefined) {
              poData = item['hire_purchase_orders'][po.POPH_Reference]
            }
            newItem.hire_purchase_orders[po.POPH_Reference] = poData
          })
          newPlants.push(newItem)
        })
        this.usedPlants = [...newPlants]
        this.handlePlantsModel()
      }
    }
  },
  computed: {
    ...mapGetters({
      getActiveCall: 'calls/getActiveCall',
      getFormData: 'calls/getFormData',
      getSelectedFormId: 'calls/getSelectedFormId'
    }),

    plantOrderData() {
      const formData = this.getFormData[this.getSelectedFormId]
      if (formData) {
        return formData.plant || []
      }
      return []
    },

    po_type() {
      return this.schema.po_type
    }
  },
  watch: {}
}
</script>
<style scoped lang="scss">
[type='number'] {
  width: 100%;
}
.plant_used_item-divider {
  display: flex;
  align-items: center;
}
.plant_used_item-divider hr {
  flex-grow: 1;
}
</style>
